import { BaseProxy, type ProxyMethods } from '@/proxies/Proxy'

export default class AssignmentPriceProxy extends BaseProxy implements ProxyMethods {
  public endpoint = 'prices/assignment'

  getDefaultPrices(id: string) {
    return this.submit('get', `/${this.endpoint}/${id}/default`)
  }
}
